import React, { createContext, useContext, useState } from 'react';

const TableFilterValuesContext = createContext();

export const TableFilterValuesProvider = ({ children }) => {
  const [filterValues, setFilterValues] = useState(
    JSON.parse(localStorage.getItem('filterValues')) || {},
  );
  const [filterColumns, setFilterColumns] = useState(
    JSON.parse(localStorage.getItem('filterState'))?.filteredColumn || [],
  );

  const reset = () => {
    setFilterValues({});
    setFilterColumns([]);
  };
  console.log('Vfvsdfvs', filterValues);
  return (
    <TableFilterValuesContext.Provider
      value={{
        filterValues,
        setFilterValues,
        filterColumns,
        setFilterColumns,
        reset,
      }}
    >
      {children}
    </TableFilterValuesContext.Provider>
  );
};

export const useTableFilterValuesContext = () =>
  useContext(TableFilterValuesContext);
